export default "__VITE_PUBLIC_ASSET__a35c7096__"